import { Link } from 'react-router-dom';
import { CONTACT } from '../../config/contact';
import { ArrowIcon, PhoneIcon } from '../Icons/Icons';
import m from '../../styles/marketing.module.css';
import styles from './CtaBand.module.css';

interface Props {
  eyebrow?: string;
  title: string;
  lead: string;
}

/** The navy closing band Home ends on, over Sathorn's green between the
 *  towers. */
const CtaBand = ({ eyebrow = 'Work with us', title, lead }: Props) => (
  <section className={`${m.section} ${m.navy} ${m.onNavy} ${styles.band}`} id="contact-cta">
    <div className={styles.media} aria-hidden="true">
      <img src="/images/sathorn-green.webp" alt="" data-parallax="0.04" loading="lazy" />
    </div>
    <div className={styles.shade} />
    <div className={`${m.container} ${styles.inner}`}>
      <div data-reveal>
        <div className={m.eyebrowOnNavy}>{eyebrow}</div>
        <h2 className={`${m.midHead} ${styles.title}`}>{title}</h2>
        <p className={m.lead}>{lead}</p>
      </div>
      <div className={`${m.btnRow} ${styles.actions}`} data-reveal data-reveal-delay="90">
        <Link to="/contact" className={`${m.btn} ${m.btnLg} ${m.btnLight}`}>
          Speak with Our Team <ArrowIcon width={18} height={18} />
        </Link>
        <a href={CONTACT.phoneHref} className={`${m.btn} ${m.btnLg} ${m.btnGhostLight}`}>
          <PhoneIcon width={18} height={18} /> {CONTACT.phoneDisplay}
        </a>
      </div>
    </div>
  </section>
);

export default CtaBand;
